import km from 'keymirror'
import _ from 'underscore'

export default _.extend({}, km({
    BUYER_SHOW_BRIEF_SUCCESS: null,
    BUYER_SHOW_BRIEF_ERROR: null,
    BUYER_INFO_SUCCESS: null,
    BUYER_INFO_ERROR: null,
    BUYER_SHOW_DETAIL_SUCCESS: null,
    BUYER_SHOW_DETAIL_ERROR: null,
    BUYER_SHOW_LIST_SUCCESS: null,
    BUYER_SHOW_LIST_ERROR: null,
}))